<template>
  <div>
    <el-col>
      <h4 class="h4">
        <i class="el-icon-s-management"></i>&nbsp;&nbsp;{{ $t('preprint.submitFile.title') }}
      </h4>
      <!-- 标签放在标题下方，左对齐 -->
      <div class="file-label-container">
        <span class="req-star">*</span>
        <span class="req-text">{{ fileLabelTrimmed }}</span>
      </div>
    </el-col>

    <el-form label-width="0px" class="preprint-file-form">
      <el-form-item class="file-label-item">
        <el-upload
          class="upload-demo"
          :action="uploadUrl"
          :on-success="handleSuccess"
          :on-error="handleError"
          :before-upload="beforeUpload"
          :file-list="fileList"
          :limit="1"
          :on-exceed="handleExceed"
        >
          <div class="upload-container">
            <el-button size="small" type="primary" class="upload-button">
              {{ $t('preprint.submitFile.selectFileButton') }}
            </el-button>
            <span class="upload-tip">{{ $t('preprint.submitFile.fileTip') }}</span>
          </div>
        </el-upload>
      </el-form-item>

      <el-form-item v-if="fileInfo.fileName" class="file-info-item">
        <div class="file-info-container">
          <i class="el-icon-document"></i>
          <span class="file-info-label">{{ $t('preprint.submitFile.fileNameLabel') }}</span>
          <span class="file-info-value">{{ fileInfo.fileName }}</span>
          <span class="file-info-separator">|</span>
          <span class="file-info-label">{{ $t('preprint.submitFile.filePathLabel') }}</span>
          <span class="file-info-value">{{ fileInfo.filePath }}</span>
          <el-tag type="success" size="small" class="success-tag">{{ $t('preprint.submitFile.uploadSuccess') }}</el-tag>
        </div>
      </el-form-item>
    </el-form>

    <el-row></el-row>
    <br />
    <el-col class="h4">
      <el-button class="save" @click="saveFileInfo" :disabled="!fileInfo.fileName">
        {{ $t('preprint.submitFile.saveButton') }}
      </el-button>
    </el-col>
  </div>
</template>

<script>
import config from '@/config'

export default {
  name: 'PreprintFileComponent',
  data() {
    const baseUrl = process.env.NODE_ENV === 'development' 
      ? config.baseUrl.dev 
      : config.baseUrl.pro
    return {
      uploadUrl: `${baseUrl}manuscripts/upload`,
      fileList: [],
      fileInfo: {
        fileName: '',
        filePath: ''
      }
    }
  },
  computed: {
    // 确保翻译结果去除前后空白，避免前导空白导致缩进不一致
    fileLabelTrimmed() {
      return String(this.$t('preprint.submitFile.fileLabel')).trim()
    }
  },
  methods: {
    beforeUpload(file) {
      const isValidType = file.type === 'application/pdf' ||
        file.type === 'application/msword' ||
        file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      const isLt20M = file.size / 1024 / 1024 < 20

      if (!isValidType) {
        this.$message.error(this.$t('preprint.submitFile.fileTypeError'))
        return false
      }
      if (!isLt20M) {
        this.$message.error(this.$t('preprint.submitFile.fileSizeError'))
        return false
      }
      return true
    },
    handleSuccess(response, file, fileList) {
      if (response.errorCode === 0) {
        this.fileInfo.fileName = file.name
        // 后端返回的是 filename 字段，不是 filePath
        this.fileInfo.filePath = response.result.filename || response.result.filePath || response.result
        this.$message.success(this.$t('preprint.submitFile.uploadSuccessMsg'))
      } else {
        this.$message.error(response.errorMessage || this.$t('preprint.submitFile.uploadFailed'))
      }
    },
    handleError(err, file, fileList) {
      console.error(this.$t('preprint.submitFile.uploadError'), err)
      this.$message.error(this.$t('preprint.submitFile.uploadFailed'))
    },
    handleExceed(files, fileList) {
      this.$message.warning(this.$t('preprint.submitFile.exceedLimit'))
    },
    saveFileInfo() {
      if (!this.fileInfo.fileName) {
        this.$message.warning(this.$t('preprint.submitFile.fileRequired'))
        return
      }

      // 保存到全局状态
      this.$root.$emit('savePreprintFile', this.fileInfo)
      this.$message.success(this.$t('preprint.submitFile.saveSuccess'))
    },
    loadSavedFile() {
      const saved = sessionStorage.getItem('preprintFile')
      if (saved) {
        this.fileInfo = JSON.parse(saved)
        if (this.fileInfo.fileName) {
          this.fileList = [{
            name: this.fileInfo.fileName,
            url: this.fileInfo.filePath
          }]
        }
      }
    }
  },
  mounted() {
    this.loadSavedFile()

    // 监听保存事件
    this.$root.$on('savePreprintFile', (fileInfo) => {
      sessionStorage.setItem('preprintFile', JSON.stringify(fileInfo))
    })

    // 监听加载预印本数据事件（重新提交模式）
    this.$root.$on('loadPreprintData', (data) => {
      console.log('=== preprintFileComponent 接收到数据 ===')
      console.log('接收到的数据:', data)
      console.log('文件路径:', data ? data.manuscriptFilePath : null)
      console.log('文件名:', data ? data.manuscriptFileName : null)
      
      if (data && data.manuscriptFilePath) {
        this.fileInfo = {
          fileName: data.manuscriptFileName || '已上传文件',
          filePath: data.manuscriptFilePath
        }
        this.fileList = [{
          name: this.fileInfo.fileName,
          url: this.fileInfo.filePath
        }]
        console.log('设置后的文件信息:', this.fileInfo)
        console.log('设置后的文件列表:', this.fileList)
        // 同时保存到 sessionStorage
        sessionStorage.setItem('preprintFile', JSON.stringify(this.fileInfo))
      }
    })
  },
  beforeDestroy() {
    this.$root.$off('savePreprintFile')
    this.$root.$off('loadPreprintData')
  }
}
</script>

<style scoped>
.h4 {
  text-align: left;
  margin-left: 20px;
}

/* 标签容器：放在标题下方，左对齐，确保三种语言对齐 */
.file-label-container {
  margin-left: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  line-height: 1.5;
  font-size: 14px;
}

.save {
  background-color: #054a48;
  color: white;
  width: 150px;
  border: none;
  border-radius: 0px;
}

button:hover {
  background-color: #0a696f;
  color: white;
  border-radius: 0px;
}

/* 星号样式 */
.req-star {
  color: #f56c6c;
  margin-right: 4px;
  font-size: 14px;
  flex-shrink: 0;
  line-height: 1.5;
}

/* 文字样式，确保三种语言横向显示 */
.req-text {
  font-size: 14px;
  white-space: nowrap;
  line-height: 1.5;
  word-break: keep-all;
  overflow: visible;
  /* 确保日语文字不换行 */
  word-wrap: normal;
  overflow-wrap: normal;
}

/* 表单容器：确保有足够宽度 */
.preprint-file-form {
  width: 100% !important;
}

.preprint-file-form ::v-deep .el-form-item {
  margin-bottom: 18px;
}

/* 表单项不需要label，内容区域左对齐 */
.file-label-item ::v-deep .el-form-item__content {
  margin-left: 0 !important;
  width: 100% !important;
}

/* 文件信息表单项：确保内容区域有足够宽度，不影响内部flex布局 */
.file-info-item ::v-deep .el-form-item__content {
  margin-left: 0 !important;
  width: 100% !important;
  max-width: 100% !important;
  overflow: visible !important;
  /* 不设置 display: block，让内部 flex 布局正常工作 */
}

/* 上传区域：按钮和提示文字横向排列 */
.upload-container {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.upload-button {
  background-color: #0a666b;
  border: none;
}

.upload-tip {
  color: #909399;
  font-size: 12px;
  line-height: 1.5;
}

/* 文件信息容器：横向布局，与预印本文件标签格式一致 */
.file-info-container {
  color: #606266;
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: flex-start !important;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 14px;
  line-height: 1.5;
  margin-left: 20px;
  margin-top: 10px;
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  /* 强制横向布局，防止被其他样式覆盖 */
  box-sizing: border-box;
}

.file-info-container .el-icon-document {
  font-size: 16px;
  color: #409eff;
  flex-shrink: 0;
}

.file-info-label {
  font-weight: 500;
  color: #909399;
  white-space: nowrap !important;
  word-break: keep-all;
  overflow: visible;
  word-wrap: normal;
  overflow-wrap: normal;
  display: inline-block !important;
  flex-shrink: 0;
}

.file-info-value {
  color: #606266;
  white-space: nowrap !important;
  word-break: keep-all;
  overflow: visible;
  word-wrap: normal;
  overflow-wrap: normal;
  display: inline-block !important;
  flex-shrink: 0;
}

.file-info-separator {
  color: #dcdfe6;
  margin: 0 4px;
  flex-shrink: 0;
}

.success-tag {
  margin-left: 8px;
  flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/preprint/preprintFileComponent.vue